import React from "react"
import "./assets/widget-icon.scss"

export default (props: any) => {
  const { value } = props

  return (
    <svg viewBox="0 0 248 48" width="100%" height="100%">
      <text
        y="16"
        x="50%"
        fill={"var(--gray-800)"}
        style={{ fontSize: "24px", textAnchor: "middle" }}
      >
        {value + "%"}
      </text>
      <rect
        width="248"
        y="24"
        x="0"
        height="24"
        fill={"var(--green-500)"}
      />
      <rect
        width="153"
        y="24"
        x="0"
        height="24"
        fill={"var(--yellow-500)"}
      />
      <rect
        width="82"
        y="24"
        x="0"
        height="24"
        fill={"var(--red-500)"}
      />
      <line
        x1={(248 * value) / 100}
        x2={(248 * value) / 100}
        y1="48"
        y2="20"
        stroke={"var(--gray-800)"}
        style={{ strokeWidth: "2" }}
      />
    </svg>
  )
}
